export const SIGNUP_FORM = 'SIGNUP_FORM';

export const RESTRICTED_COUNTRY_MODAL = 'RESTRICTED_COUNTRY_MODAL';
